import { Translation } from '@ps/web-shared-components';
import React, { useEffect, useState } from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import ButtonGroup from '../ButtonGroup/ButtonGroup';
import Container from '../Container/Container';
import DepositTransitionScreen from '../Deposit/components/DepositTransitionScreen/DepositTransitionScreen';

import { TXTWCL_Choose_Bonus, TXTWCL_Get_your_new_player_bonus } from './BonusOffer.messages.json';
import BonusCards from './components/BonusCards/BonusCards';
import ClaimBonusCode from './components/ClaimBonusCode/ClaimBonusCode';
import SkipBonusCode from './components/SkipBonusCode/SkipBonusCode';

export type BonusTab = 'ownBonus' | 'crmBonus' | '';
interface Props {
  isDepositFlow?: boolean;
}

const BonusOffer: React.FC<Props> = ({ isDepositFlow }) => {
  const {
    data,
    values: { deposit }
  } = useWizardContext();
  const { crmBonusCode, signupPassed, mitIdResultContext, rmfPassed } = data;
  const [selectedTab, setSelectedTab] = useState<BonusTab>(
    !deposit?.bonusCode ? '' : deposit?.bonusCode === crmBonusCode ? 'crmBonus' : 'ownBonus'
  );

  useEffect(() => {
    delete data.bonusCodeDetails;
  }, [data?.bonusCodeDetails]);

  return (
    <Container
      page={BonusOffer}
      headerProps={{
        title: <Translation {...TXTWCL_Choose_Bonus} />,
        buttons: {
          back: !signupPassed && isDepositFlow && !mitIdResultContext && !rmfPassed,
          exitWizardOnBackClick: true
        }
      }}
      hideBonusSummary
      pageTopTitle={<Translation {...TXTWCL_Get_your_new_player_bonus} />}
      showFooter
    >
      <DepositTransitionScreen />
      <BonusCards selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      <ButtonGroup>
        <ClaimBonusCode selectedTab={selectedTab} />
        <SkipBonusCode setSelectedTab={setSelectedTab} />
      </ButtonGroup>
    </Container>
  );
};
BonusOffer.displayName = 'BonusOffer';

export default BonusOffer;
